module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    attrs: {
      "id": "_idParaDest-10",
      "title": "Part 1: Why Study Philosophy?"
    }
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page17",
      "title": "17"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "part-number"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor041"
    }
  }), _vm._v("PART ONE\n      ")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "_idParaDest-12"
    }
  }, [_vm._v("WHY STUDY PHILOSOPHY?")]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page18",
      "title": "18"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15b8fb46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/pt1.vue
// module id = 72
// module chunks = 0